import type { GeneralObject } from '@scansource-brazil/zeus-core-ui/types';
import type { MySsApiResponse } from '~/types/MySsApiResponse';

import { AdaptCompany } from '~/adapters/CompanyAdapter';
import { Company } from '../models/Company';
import { SalesCommissionFiltersOutputDTO } from '~/models/Commission';
import { get, patch, post } from '~http';

const baseUrl = 'companies';

async function getCompany(params: any) {
  const queryParams = params.map((doc: any) => `CompanyDocument=${doc}`).join('&');
  return await get(`${baseUrl}?${queryParams}`);
}

export async function getCompanyByDocument(companyDocument: string) {
  return getCompany({ companyDocument }).then(
    (response: any) => AdaptCompany.toModel(response.data.data.at(0)),
    (error) => {
      throw error;
    },
  );
}

export async function getEconomicGroupMembers(
  companiesDocuments: string[],
): Promise<Company[]> {
  return getCompany(companiesDocuments).then(
    (response: any) => AdaptCompany.toModelList(response.data.data),
    (error) => {
      throw error;
    },
  );
}

export async function requestAccess(companyDocument: string) {
  return await post(`requests/${companyDocument}`, {}).then(
    (response: any) => response,
    (error) => {
      throw error;
    },
  );
}

export async function getSolicitationData(solicitationCode: string) {
  return await get(
    `requests/${solicitationCode}`,
    {},
    { headers: { mayBeUnauthenticated: false } },
  ).then(
    (response: any) => response.data,
    (error) => {
      throw error;
    },
  );
}

// não funcionou passando os parâmetros corretamente
export async function respondingSolicitation(solicitation: any) {
  return await patch(
    `requests/${solicitation.id}?requestStatus=${solicitation.aproved}`,
    {},
    { headers: { mayBeUnauthenticated: false } },
  ).then(
    (response: any) => response,
    (error: any) => {
      throw error;
    },
  );
}

export async function listCommissionsTotalizers(
  companyDocument: string,
  params: GeneralObject = {},
) {
  return await get(
    `${baseUrl}/${companyDocument}/sales-commissions/summary`,
    params,
  ).then(
    ({ data }: MySsApiResponse) => data,
    (error) => {
      throw error;
    },
  );
}
export async function listCommissions(
  companyDocument: string,
  params = new SalesCommissionFiltersOutputDTO(),
) {
  return await get(`${baseUrl}/${companyDocument}/sales-commissions`, params).then(
    ({ data }: MySsApiResponse) => data,
    (error) => {
      throw error;
    },
  );
}

export async function showCommission(
  companyDocument: string,
  salesCommissionId: string,
): Promise<any> {
  return await get(
    `${baseUrl}/${companyDocument}/sales-commissions/${salesCommissionId}`,
  ).then(
    ({ data }: MySsApiResponse) => data,
    (error) => {
      throw error;
    },
  );
}
